import React from "react";
import Margin from "../../Margin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import OffersByCategory from "./Graphs/OffersByCategory";
import OffersByMonth from "./Graphs/OffersByMonth";
import OffersByTransmitter from "./Graphs/OffersByTransmitter";
import OffersByCategoryByMonth from "./Graphs/OffersByCategoryByMonth";
import OffersByDiffuser from "./Graphs/OffersByDiffuser";
import useWindowDimensions from "Services/useWindowsDimensions";
import OffersTable from "Components/Stats/Tables/OffersTable";
import OffersByDomainByPeriod from "./Graphs/OffersByDomainByPeriod";

/**
 * Le module 'OffresModule' sert à afficher les graphiques de la partie offres
 * à l'aide de la librairie Nivo, et de composants génériques créés à partir de
 * cette librairie.
 *
 * Les données formatées des graphiques proviennent du dossier Data (dont les fonctions reçoivent les données API),
 * et sont stockées grâce aux hooks {@link useState}.
 *
 * La liste des graphiques :
 * - Nombre d'offres par catégorie (camembert) : {@link OffersByCategory}
 * - Nombre d'offres par mois (barres) : {@link OffersByMonth}
 * - Nombre d'offres par catégorie par mois (barres) : {@link OffersByCategoryByMonth}
 * - Nombre d'offres par domaine par mois (barres) : {@link OffersByDomainByMonth}
 * - Nombre d'offres par transmetteur | profil (camembert) : {@link OffersByTransmitter}
 * - Nombre d'offres par diffuseur par catégorie (barres + camembert) : {@link OffersByDiffuser}
 * - Tableau récapitulatif des offres : {@link OffersTable}
 */
const OffresModule = (props) => {
  // ------------------------------ UNIVERSIÉ ACTUELLE ------------------------------
  const currentUniversity = props.auth.universityConnected || "Erreur";
  // --------------------------------------------------------------------------------

  const dimensions = useWindowDimensions();

  return (
    <div className="stats_container">
      {/* Vraies données */}
      <OffersByCategory universityName={currentUniversity.name} />
      <OffersByMonth universityName={currentUniversity.name} />
      <OffersByCategoryByMonth universityName={currentUniversity.name} />
      <OffersByDomainByPeriod universityName={currentUniversity.name} />
      <OffersByTransmitter universityName={currentUniversity.name} />

      {/* Fausses données */}
      <OffersByDiffuser universityName={currentUniversity.name} />

      {/* Si sur téléphone ne pas afficher le tableau */}
      {dimensions.width > 600 && <OffersTable />}
      <Margin position="bottom" size="s" />
    </div>
  );
};

OffresModule.propTypes = {
  offers: PropTypes.any,
  auth: PropTypes.any,
  states: PropTypes.any,
  secondaryTables: PropTypes.any,
};

const mapStateToProps = (state) => ({
  offers: state.offers,
  states: state.states,
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});

export default connect(mapStateToProps)(OffresModule);
